import React from 'react';
import shareIcon from '../../assets/sso/share.svg';
import logoIA from '../../assets/sso/ia.svg';
import iconArrow from '../../assets/black-arrow-left.svg';
import CustomTooltip from './CustomTooltip';
import { ReviewCardActionsProps } from '../type';

const ReviewCardActions: React.FC<ReviewCardActionsProps> = ({
    review,
    hasReply,
    onShare,
    onReply,
    onOpinionSystemRedirect,
}) => {
    const ShareButton = () => (
        <button
            className="flex leading-6 rounded-[1.5rem] w-fit text-medium font-medium border border-light-gray bg-white items-center content-center px-[18px] py-[10px] text-dark-gray flex-row justify-center"
            onClick={() => onShare(review)}
        >
            <img src={shareIcon} className="w-[20px] h-[20px]" alt="partager" />
            <span className="text-[#393939] text-center text-[16px] font-semibold leading-[120%] ml-2">
                Partager
            </span>
        </button>
    );

    const ReplyButton = () => (
        <button
            className="flex leading-6 rounded-[1.5rem] w-fit text-medium font-medium border border-primary bg-primary items-center content-center px-[18px] py-[10px] text-dark-gray flex-row justify-center"
            onClick={() => onReply(review)}
        >
            <img src={logoIA} className="w-[20px] h-[20px]" alt="" />
            <span className="text-[#393939] text-center text-[16px] font-semibold leading-[120%] ml-1">
                Répondre
            </span>
        </button>
    );

    const OpinionSystemButton = () => (
        <CustomTooltip
            message="Réponse à effectuer sur la plateforme Opinion System."
            delay={500}
            position="bottom"
            backgroundColor="var(--primary-light)"
            textColor="var(--dark-gray)"
            arrowColor="#E5E5E5"
        >
            <button
                className="flex leading-6 rounded-[1.5rem] w-fit text-medium font-medium border border-primary bg-primary items-center content-center px-[18px] py-[10px] text-dark-gray flex-row justify-center"
                onClick={() =>
                    onOpinionSystemRedirect(review.single_survey_link || review.external_url || '#')
                }
            >
                <img className="w-6 h-6 rotate-180" src={iconArrow} alt="flêche" />
                <span className="text-[#393939] text-center text-[16px] font-semibold leading-[120%]">
                    Voir l'avis
                </span>
            </button>
        </CustomTooltip>
    );

    const renderActions = () => {
        if (hasReply) {
            return (
                <div className="flex flex-col w-full">
                    <div
                        className="mt-auto flex justify-center"
                        style={{ borderColor: 'var(--light-gray, #E4E4E4)' }}
                    >
                        <ShareButton />
                    </div>
                </div>
            );
        }

        if (review.network === 'opinion_system') {
            return (
                <>
                    <OpinionSystemButton />
                    <ShareButton />
                </>
            );
        }

        return (
            <>
                <ReplyButton />
                <ShareButton />
            </>
        );
    };

    return (
        <div
            className="mt-auto flex justify-center pt-5 border-t gap-2"
            style={{ borderColor: 'var(--light-gray, #E4E4E4)' }}
        >
            {renderActions()}
        </div>
    );
};

export default ReviewCardActions;
